import { useEffect } from "react";
import siteConfig from "../../config/siteConfig";

const upsertMeta = (name, content, attribute = "name") => {
  if (!content || typeof document === "undefined") return;
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, name);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const PageMeta = ({ title, description, image }) => {
  useEffect(() => {
    const pageTitle = title
      ? siteConfig.seo.titleTemplate.replace("%s", title)
      : siteConfig.seo.defaultTitle;
    const pageDescription = description || siteConfig.seo.defaultDescription;

    document.title = pageTitle;
    upsertMeta("description", pageDescription);
    upsertMeta("og:title", pageTitle, "property");
    upsertMeta("og:description", pageDescription, "property");
    if (image) upsertMeta("og:image", image, "property");
  }, [description, image, title]);

  return null;
};

export default PageMeta;
